import { Fragment } from "react";
import { useCollapsePanel } from "hooks/useCollapsePanel";
import { v4 as uuidv4 } from "uuid";
import { getName, phoneNumberFormatting } from "js/formatting";
import { useTranslation } from "react-i18next";

const AgentDetailCard = ({ cardTitle, agents }) => {
  const uuid = uuidv4();
  useCollapsePanel(uuid);
  const { t } = useTranslation();
  return (
    <div className="ui-card">
      <div className="p-4 xl:pt-6 xl:px-6">
        <div className="flex flex-col md:flex-row md:justify-between md:items-center">
          <h2 className="mb-0">
            <button
              id={uuid}
              className="mb-0 flex items-center group md:hidden"
              aria-controls={`${uuid}-panel`}
              aria-expanded="true"
              aria-label={t("AgentDetailCard-expand-collapse-btn-label")}
            >
              <span className="inline-block p-1 rounded-full mr-1 text-ui-blue group-hover:text-white group-hover:bg-ui-blue">
                <svg
                  className="ui-icon ui-plus w-4 h-4"
                  focusable="false"
                  aria-hidden="true"
                  role="presentation"
                >
                  <use href="#ui-icon-plus"></use>
                </svg>
                <svg
                  className="ui-icon ui-minus w-4 h-4"
                  focusable="false"
                  aria-hidden="true"
                  role="presentation"
                >
                  <use href="#ui-icon-minus"></use>
                </svg>
              </span>
              <span className="text-base font-body font-bold">{cardTitle}</span>
            </button>
            <span className="text-xl font-body font-bold hidden md:block">
              {cardTitle}
            </span>
          </h2>
        </div>
      </div>
      <hr className="ui-mobile-collapse" />
      <div
        id={`${uuid}-panel`}
        className="overflow-hidden h-20 p-4 md:h-auto xl:p-6"
      >
        {agents.map((agent) => {
          const currentAgent = agent?.parties[0];
          const { addressLine1, addressLine2, city, state, postalCode } =
            currentAgent.address;
          const { phoneNumber } = currentAgent.phone;
          const { address: emailAddress } = currentAgent.email;

          return (
            <div
              key={`agent detail card - ${currentAgent.person.fullName}`}
              className={`grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:gap-6 mb-6`}
            >
              <div>
                <div className="text-xs text-theme-text-tertiary">
                  {t("AgentInfoCard-card-label-1")}
                </div>
                <div className="text-sm font-semibold text-theme-text-secondary">
                  {getName(currentAgent.person)}
                </div>
              </div>
              <div>
                <div className="text-xs text-theme-text-tertiary">
                  {t("AgentInfoCard-card-label-2")}
                </div>
                <div className="text-sm font-semibold text-theme-text-secondary">
                  <div>
                    {addressLine1}
                    {addressLine2}
                  </div>
                  <div>{`${city}, ${state} ${postalCode.substring(0, 5)}`}</div>
                </div>
              </div>
              <div>
                <div className="text-xs text-theme-text-tertiary">
                  {t("AgentInfoCard-card-label-3")}
                </div>
                <div className="text-sm font-semibold text-theme-text-secondary">
                  <a href={`tel:+1${phoneNumber}`}>
                    {phoneNumberFormatting(phoneNumber)}
                  </a>
                </div>
              </div>
              <div>
                <div className="text-xs text-theme-text-tertiary">
                  {t("AgentInfoCard-card-label-4")}
                </div>
                <div className="text-sm font-semibold text-theme-text-secondary break-words">
                  <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default AgentDetailCard;
